import { Checkbox, Col, ConfigProvider, Row } from "antd";
import { DatePicker as DatePickerJalali, JalaliLocaleListener , Calendar as CalendarJalali, useJalaliLocaleListener, DatePicker} from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import { set } from "lodash";
import { ChangeEvent, useState } from "react";
//import dayjs from "dayjs";
//import jalaliday from "jalaliday";
//dayjs.extend(jalaliday);
import jalali_moment from 'jalali-moment';  
import dayjs from "dayjs";
import moment from "moment";

export interface InputProps {
    getEditFormValues:any,
    billNumber:number,
    date:any
  }


const EditTaxInfo =({getEditFormValues,billNumber,date}:InputProps)=>{
    let new_date = '';
    const [editInputValues, setEditInputValue] = useState({
        billNumber:billNumber,
        date:date == "0"? moment().format("YYYY-MM-DD") : date,
        isGroup:false
    });


    // const onChangeDatePicker = (activeDate:any) => {
        
    //     //setEditInputValue({ ...editInputValues, [{editInputValues.date}]: activeDate });
         
    // }
    function handleChange(e: any) {
        const { name, value } = e.target;     
        if (e.target.type == "checkbox") {
            setEditInputValue({ ...editInputValues, [name]: e.target.checked });
            getEditFormValues(name, e.target.checked );

        }  
        else{
            setEditInputValue({ ...editInputValues, [name]: value });
            getEditFormValues(name, value);

        }
        
    }


    function onChange(value:any, dateString:any) {
        if (value) {
        //   setFormData({
        //     ...formData,
        //     "Campaign-date": value.toISOString(true)
        //   });
        console.log(dateString);
        setEditInputValue({ ...editInputValues, date: dateString });
        getEditFormValues('date',dateString);}
        //console.log("Selected Time: ", value); //Moment object
        //console.log("Formatted Selected Time: ", dateString); //String
      }
      {//new_date = jalali_moment(editInputValues.date, 'YYYY-MM-DD').locale('fa').format('YYYY-M-D');
        new_date = jalali_moment(date).locale("en").format("YYYY-MM-DD");}

    return(
        <>
        <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
            <div className="form-control"
                        style={{ marginBottom: '18px' }} >
                            <input style={{padding:'0px'}}
                            placeholder="شماره فاکتور "
                            type="string"
                            autoComplete="false"
                            name="billNumber"
                            id="billNumber"
                            className="input-field"
                            onChange={(e) => handleChange(e)}
                            value={editInputValues.billNumber}
                            />                                           
            </div>
            </Col>
        <Col lg={12} md={12} sm={12} xs={12}
            style={{ marginTop: '4px' }}
            className="calender">
            <ConfigProvider locale={fa_IR} direction="rtl">
                <JalaliLocaleListener />
                <DatePicker defaultValue={dayjs(new_date, "YYYY-MM-DD")} format={"YYYY-MM-DD"}
                onChange={onChange} dateString={editInputValues.date}
                //onChange={(e:any) => handleChange(e)}
                 />
            </ConfigProvider>
        </Col>
    </Row>
    <Row>
    <Checkbox
        name="isGroup"
        onChange={(e) => handleChange(e)}
        value={editInputValues.isGroup}
    >
    {"این شماره فاکتور فقط برای این فاکتور لحاظ شود."}
    </Checkbox>
    </Row>
    </>
    )
}
export default EditTaxInfo;